import { render, staticRenderFns } from "./VisionMissionTitle.vue?vue&type=template&id=3b4d2a0e&"
import script from "./VisionMissionTitle.vue?vue&type=script&lang=js&"
export * from "./VisionMissionTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports